import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { BLOG_POSTS } from "./posts";

const Blogs = () => {
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1, // Delay for each letter
        type: "spring",
        stiffness: 120,
      },
    }),
  };
  const headingText = "Blogs";

  const title = "Blogs";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.05, // Delay for each letter
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };
  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title> Blogs | Money Service Business Advocacy UK</title>
        <meta name="description" content="" />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="Blogs | Money Service Business Advocacy UK "
        />
        <meta property="og:description" content="" />

        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
================================================== */}
        <section
          id="overview"
          className="page_header text-center  section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
            <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{ display: "flex", justifyContent: "center" }}
            >
              {title.split("").map((letter, index) => (
                <motion.span
                  key={index}
                  custom={index}
                  variants={letterVariants}
                  style={{
                    display: "inline-block",
                    marginRight: letter === " " ? "0.3rem" : "0",
                    whiteSpace: "pre",
                  }}
                >
                  {letter}
                </motion.span>
              ))}
            </motion.h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="active">
                <a href="#!">Blogs</a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
================================================== */}
        {/* Contact Section - Start
================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="row justify-content-start">
              {BLOG_POSTS.map((post) => (
                <div
                  key={post.slug}
                  className="col-md-6 col-lg-6 col-xl-4 mix trending featured mb-2"
                  data-bound
                >
                  <div className="course-single-item">
                    <div className="d-block course-single-item-img">
                      <img src={post.image} alt={post.title} />
                    </div>
                    <div className="course-single-item-content-bg">
                      <div className="course-single-item-content">
                        <h3>
                          <NavLink to={post.slug}>{post.title}</NavLink>
                        </h3>
                        {post.date && (
                          <>
                            <i className="fa-regular fa-calendar-days"></i>{" "}
                            {new Date(post.date).toLocaleDateString("en-GB", {
                              year: "numeric",
                              month: "short",
                              day: "2-digit",
                            })}
                          </>
                        )}
                        {post.excerpt && <p className="mt-2 mb-0">{post.excerpt}</p>}
                      </div>
                      <div className="d-flex justify-content-center course-single-item-price-cart">
                        <NavLink to={post.slug} className="btn btn-primary btn-hover-secondary">
                          Read More
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Blogs;
